// @ts-nocheck
import {AxiosInstance, AxiosResponse} from 'axios';
import {Platform} from 'react-native';
import Package from '../../../package.json';
import {network} from 'src/constants/config';
import {
  Res,
  TripCheckoutBodyType,
  TripCheckoutResponseType,
  callrequestResponseType,
  changePhoneNumberResponseType,
  damageReportBodyType,
  damageReportResponseType,
  dashboardInvalidLocationBodyType,
  dashboardInvalidLocationResponseType,
  dashboardMyTransactionsResponseType,
  dashboardMyTripsResponseType,
  discountCheckBodyType,
  discountCheckResponseType,
  feedbackForeignImmigrantsBodyType,
  feedbackForeignImmigrantsResponseType,
  feedbackResponseType,
  getConfigResponseType,
  inquiryBodyType,
  inquiryResponseType,
  inquiryVerificationBodyType,
  inquiryVerificationResponseType,
  packagesBuyBodyType,
  packagesBuyResponseType,
  packagesMyPackagesResponseType,
  packagesResponseType,
  paymentRequestPaymentBodyType,
  paymentRequestPaymentResponseType,
  postFeedbackBodyType,
  postPhoneAccessBodyType,
  postPhoneAccessResponseType,
  postProfileBodyType,
  profileResponseType,
  putProfileBodyType,
  putProfileResponseType,
  reserveBodyType,
  reserveCancelBodyType,
  reserveResponseType,
  stationsResponseType,
  tokenBodyType,
  tokenResponseType,
  tripCheckoutCalculatorBodyType,
  tripOptionsBeepBodyType,
  tripOptionsBeepResponseType,
  tripOptionsOpenboxBodyType,
  tripOptionsOpenboxResponseType,
  tripOptionsUnlockResponseType,
  tripsEndBodyType,
  tripsPauseResumeBodyType,
  tripsPauseResumeResponseType,
  tripsStartBodyType,
  tripsStartResponseType,
  uploadImageBodyType,
  uploadImageResponseType,
  vehiclesGetIdBodyType,
  vehiclesGetIdResponseType,
  vehiclesResponseType,
} from './ServerTypes';

type Query = (p: any) => PromiseLike<any> | void;
type ApiType = {
  [key: string]: ApiType | Query;
};

const format = <T extends ApiType>(input: T) => input as T;

const os = Platform.OS;
const api = network.api_route;
const auth = network.auth_route;

const backgroundApiCallHeader = {
  headers: {
    'Background-Api-Call': true,
  },
};
const backgroundApiCallHeaderStation = {
  headers: {
    'Background-Api-Call': true,
    'X-Api-Version': 2,
  },
};

export const createApi = (axios: AxiosInstance) => {
  return format({
    async getConfig(params) {
      const res = await axios.get(`${api}/configuration`, {
        params,
        ...backgroundApiCallHeader,
      });
      return handle<getConfigResponseType>(res);
    },
    async postPhoneAccess(p?: postPhoneAccessBodyType) {
      const res = await axios.post(`${auth}/PostPhoneAccess`, p);
      return handle<postPhoneAccessResponseType>(res);
    },
    async token(p?: tokenBodyType) {
      const res = await axios.post(`${auth}/Token`, p);
      return handle<tokenResponseType>(res);
    },
    async vehicles(params) {
      const res = await axios.get(`${api}/vehicles`, {
        params,
        ...backgroundApiCallHeader,
      });
      return handle<vehiclesResponseType>(res);
    },
    async lastPaymentStatus(params) {
      const res = await axios.get(`${api}/profile/GetLastPaymentStatus`, {
        params,
        ...backgroundApiCallHeader,
      });
      return handle<vehiclesResponseType>(res);
    },
    async stations() {
      const res = await axios.get(`${api}/stations`, backgroundApiCallHeader);
      return handle<stationsResponseType>(res);
    },
    async dashboardMyTrips() {
      const res = await axios.get(
        `${api}/dashboard/MyTrips`,
        backgroundApiCallHeader,
      );
      return handle<dashboardMyTripsResponseType>(res);
    },
    async myActiveTrip() {
      const res = await axios.get(
        `${api}/dashboard/MyActiveTrip`,
        backgroundApiCallHeader,
      );
      return handle<any>(res);
    },
    async myTripsHeader() {
      const res = await axios.get(`${api}/dashboard/MyTripsHeader`);
      return handle<any>(res);
    },
    async myTripsHistory(p) {
      const res = await axios.get(`${api}/dashboard/MyTripsHistory`, p);
      return handle<any>(res);
    },
    async unsilentDashboardMyTrips() {
      const res = await axios.get(`${api}/dashboard/MyTrips`);
      return handle<dashboardMyTripsResponseType>(res);
    },
    async profile() {
      const res = await axios.get(`${api}/profile`, backgroundApiCallHeader);
      return handle<profileResponseType>(res);
    },
    async unsilentProfile() {
      const res = await axios.get(`${api}/profile`);
      return handle<profileResponseType>(res);
    },
    async inquiryGetProfile(p?: inquiryGetProfileBodyType) {
      const res = await axios.post(`${api}/Inquiry/GetProfile`, p);
      return handle<inquiryGetProfileResponseType>(res);
    },
    async inquiry(p?: inquiryBodyType) {
      const res = await axios.post(`${api}/inquiry`, p);
      return handle<inquiryResponseType>(res);
    },
    async inquiryVerification(p?: inquiryVerificationBodyType) {
      const res = await axios.post(`${api}/inquiryVerification`, p);
      return handle<inquiryVerificationResponseType>(res);
    },
    async reserve(p?: reserveBodyType) {
      const res = await axios.get(`${api}/reserve?vehicleId=${p?.vehicle_id}`);
      return handle<reserveResponseType>(res);
    },
    async tripOptionsBeep(p?: tripOptionsBeepBodyType) {
      const res = await axios.post(`${api}/tripOptions/beep`, p);
      return handle<tripOptionsBeepResponseType>(res);
    },
    async reserveCancel(p?: reserveCancelBodyType) {
      const res = await axios.get(
        `${api}/reserve/cancel?reserveId=${p?.reserve_id}`,
      );
      return handle<reserveResponseType>(res);
    },
    async tripsStart(p?: tripsStartBodyType) {
      const res = await axios.post(`${api}/Trips/start`, p);
      return handle<tripsStartResponseType>(res);
    },
    async tripsPauseResume(p?: tripsPauseResumeBodyType) {
      const res = await axios.put(`${api}/Trips/PauseResume`, p);
      return handle<tripsPauseResumeResponseType>(res);
    },
    async tripOptionsOpenbox(p?: tripOptionsOpenboxBodyType) {
      const res = await axios.get(
        `${api}/tripOptions/openbox?tripId=${p?.trip_id}`,
      );
      return handle<tripOptionsOpenboxResponseType>(res);
    },
    async tripOptionsUnlock() {
      const res = await axios.get(`${api}/tripOptions/unlock`);
      return handle<tripOptionsUnlockResponseType>(res);
    },
    async TripsEnd(p?: tripsEndBodyType) {
      const res = await axios.put(`${api}/Trips/end`, p, {
        headers: {
          'X-Api-Version': 2,
        },
      });
      return handle<tripOptionsUnlockResponseType>(res);
    },
    async tripCheckoutCalculator(p?: tripCheckoutCalculatorBodyType) {
      const res = await axios.post(`${api}/TripCheckout/calculator`, p);
      return handle<tripOptionsUnlockResponseType>(res);
    },
    async paymentRequestPayment(p?: paymentRequestPaymentBodyType) {
      const res = await axios.post(`${api}/Payment/RequestPayment`, p);
      return handle<paymentRequestPaymentResponseType>(res);
    },
    async requestBikeSubscription() {
      const res = await axios.patch(`${api}/Payment/RequestBikeSubscription`);
      return handle<any>(res);
    },
    async discountCheck(p?: discountCheckBodyType) {
      const res = await axios.get(
        `${api}/Discount/check?code=${p?.discount_code}`,
      );
      return handle<discountCheckResponseType>(res);
    },
    async packagesMyPackages() {
      const res = await axios.get(
        `${api}/packages/MyPackages`,
        backgroundApiCallHeader,
      );
      return handle<packagesMyPackagesResponseType>(res);
    },
    async TripCheckout(p?: TripCheckoutBodyType) {
      const res = await axios.post(`${api}/TripCheckout`, p);
      return handle<TripCheckoutResponseType>(res);
    },
    async uploadImage(p?: uploadImageBodyType, config) {
      const res = await axios.post(`${api}/uploadImage`, p, config);
      return handle<uploadImageResponseType>(res);
    },
    async postProfile(p?: postProfileBodyType) {
      const res = await axios.post(`${api}/profile`, p);
      return handle<profileResponseType>(res);
    },
    async packages() {
      const res = await axios.get(`${api}/packages`);
      return handle<packagesResponseType>(res);
    },
    async packagesBuy(p?: packagesBuyBodyType) {
      const res = await axios.get(
        `${api}/packages/buy?packageId=${p?.package_id}`,
      );
      return handle<packagesBuyResponseType>(res);
    },
    async dashboardMyTransactions(p) {
      const res = await axios.get(`${api}/dashboard/MyTransactions`, p);
      return handle<dashboardMyTransactionsResponseType>(res);
    },
    async feedback() {
      const res = await axios.get(`${api}/feedback`);
      return handle<feedbackResponseType>(res);
    },
    async postFeedback(p?: postFeedbackBodyType) {
      const res = await axios.post(`${api}/feedback`, p);
      return handle<feedbackResponseType>(res);
    },
    async feedbackForeignImmigrants(p?: feedbackForeignImmigrantsBodyType) {
      const res = await axios.post(`${api}/feedback/ForeignImmigrants`, p);
      return handle<feedbackForeignImmigrantsResponseType>(res);
    },
    async callrequest() {
      const res = await axios.get(`${api}/callrequest`);
      return handle<callrequestResponseType>(res);
    },
    async vehicleDetail(p) {
      const res = await axios.get(`${api}/DamageReport/GetReportsStatuses`, p);
      return handle<callrequestResponseType>(res);
    },
    async damageReport(p?: damageReportBodyType) {
      const res = await axios.post(`${api}/DamageReport`, p);
      return handle<damageReportResponseType>(res);
    },
    async putProfile(p?: putProfileBodyType) {
      const res = await axios.put(`${api}/profile`, p);
      return handle<putProfileResponseType>(res);
    },
    async changePhoneNumber() {
      const res = await axios.post(`${auth}/ChangePhoneNumber`);
      return handle<changePhoneNumberResponseType>(res);
    },
    async dashboardInvalidLocation(p?: dashboardInvalidLocationBodyType) {
      const res = await axios.post(
        `${api}/dashboard/InvalidLocation`,
        p,
        backgroundApiCallHeader,
      );
      return handle<dashboardInvalidLocationResponseType>(res);
    },
    async vehiclesGetId(p?: vehiclesGetIdBodyType) {
      const res = await axios.get(
        `${api}/vehicles/GetId?code=${p?.code}`,
        backgroundApiCallHeader,
      );
      return handle<vehiclesGetIdResponseType>(res);
    },
    async healthCheck() {
      const res = await axios.get(
        `HealthCheck?token=V94PHPxXWV4lWPn7Gl1IOnqq1ze4ubKx`,
        backgroundApiCallHeader,
      );
      return handle(res);
    },
    async getTripPaymentDetail(params) {
      const res = await axios.get(`${api}/Trips/GetPaymentDetails`, {
        params,
        ...backgroundApiCallHeader,
      });
      return handle(res);
    },
    async learningVideos(p?: vehiclesGetIdBodyType) {
      const res = await axios.get(`${api}/configuration/GetLearningItems`, {
        headers: {
          // 'X-Api-Version': 3,
          'X-Api-Version': 4,
        },
      });
      return handle<vehiclesGetIdResponseType>(res);
    },
    async profileGetNationalCardStatus() {
      const res = await axios.get(`${api}/Profile/GetNationalCardStatus`);
      return handle<any>(res);
    },
    async getMessages(p) {
      const res = await axios.get(`${api}/messages`, p);
      return handle<any>(res);
    },
    async getMessage(p) {
      const res = await axios.get(`${api}/messages/getmessage?id=${p}`);
      return handle<any>(res);
    },
    async putMessages(p) {
      const res = await axios.put(`${api}/messages`, p);
      return handle<any>(res);
    },
    async checkFeedback(p) {
      const res = await axios.get(`${api}/Feedback/CheckFeedback`, p);
      return handle<any>(res);
    },
    async checkDangerousRide(p) {
      const res = await axios.get(`${api}/Trips/EndTripNecessities`, p);
      return handle<any>(res);
    },
    async dashboardMyUnpaidTrips(params) {
      const res = await axios.get(`${api}/dashboard/MyUnpaidTrips`, {
        params,
        ...backgroundApiCallHeader,
      });
      return handle<any>(res);
    },
  });
};

function handle<T>(res: AxiosResponse<Res<T>>) {
  if (res.status >= 200 && res.status < 300) {
    return res.data;
  }
  throw res.data;
}
